/**
 * @name: 数据字典项
 * @description:
 * @author: Wood
 * @date: 2021/5/23
 * @update:
 */
import React, {useState, useRef} from 'react';
import {Card, Button, Space, Divider} from 'antd';
import {Link} from 'react-router-dom';
import PageContent from '../../../components/page-content/page-content';
import DataTable from '../../../components/data/data-table2';
import SysDictAddModal from './roles-add-modal';
import SysDictEditModal from './roles-edit-modal';
// import {useTable} from '../../../components/m-table';
import {PlusOutlined} from '@ant-design/icons';
import Detail from './detail';

const SysDict = ({match}) => {
    const [visible, setVisible] = useState(false);
    const [editdata, setEditData] = useState(null);
    const [detaildata, setdetaildata] = useState(null);
    // const {refresh} = useTable();
    // console.log(match.params.type_id);
    const table = useRef();
    const config = {
        table: table,
        title: "角色",
        tableName: "roles",
        pageQuery: match.params,
        pagination: false,
        size: "small",
        columns: [{
            title: '编号',
            dataIndex: 'id',
            sorter: true,
        }, {
            title: '排序',
            dataIndex: 'order_index',
            sorter: true,
            // sortOrder:"descend"
        }, {
            title: '名称',
            dataIndex: 'name',
        }, {
            title: '描述',
            dataIndex: 'desc',
        }, {
            title: '内置',
            dataIndex: 'is_lock',
            enum: {
                0: '非内置',
                1: '内置',
            },
            filters: [{
                text: '非内置',
                value: 0,
            }, {
                text: '内置',
                value: 1,
            }]
        }, {
            title: '角色类型',
            dataIndex: 'type',
            enum: {
                1: '系统管理员',
                2: '前台',
                3: '教练',
            }
        }, {
            title: '状态',
            dataIndex: 'status',
            enum: {
                0: '正常',
                1: '停用',
            },
            filters: [{
                text: '正常',
                value: 0,
            }, {
                text: '停用',
                value: 1,
            }]
        }, {
            title: '操作',
            fixed: 'right',
            width: 150,
            render: (record) => (<Space split={<Divider type="vertical"/>}>
                {record.is_lock === 0 &&
                    <a onClick={() => {
                        setEditData(record);
                    }}>
                        修改
                    </a>
                }
                {record.type !== 1 &&
                    <a onClick={() => {
                        setdetaildata(record)
                    }}>
                        授权
                    </a>
                }
            </Space>)
        }],
        toolbar: [
            <Button
                type="primary"
                icon={<PlusOutlined/>}
                onClick={() => setVisible(true)}
            >添加</Button>
        ]
    };

    return (
        <PageContent>
            <Card bordered={false}>
                <DataTable {...config} />
            </Card>
            <SysDictAddModal
                visible={visible}
                onOk={() => {
                    setVisible(false);
                    table.current.refresh()
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                {...match.params}
            />
            {editdata &&
                <SysDictEditModal
                    visible={!!editdata}
                    data={editdata}
                    onOk={() => {
                        setEditData(null);
                        table.current.refresh()
                    }}
                    onCancel={() => {
                        setEditData(null);
                    }}
                    {...match.params}
                />
            }
            {detaildata &&
                <Detail
                    id={detaildata.id}
                    visible={!!detaildata}
                    onOk={() => {
                        setdetaildata(null);
                        table.current.refresh()
                    }}
                    onCancel={() => {
                        setdetaildata(null);
                    }}
                />
            }


        </PageContent>
    )
};


export default SysDict;


